import { Controller } from "stimulus"

export default class extends Controller {
  disconnect(): void {
    document.querySelectorAll('.discount-coupon--link-component')[0].style.display = 'none';
  }
}
